import { api } from "@/lib/api";

export const providerTypesApi = {
    // Public — no auth, used by signup / kiosk dropdowns.
    listPublic: () => api.get("/public/provider-types").then((r) => r.data.items),

    // Admin — includes inactive types and provider counts.
    listAdmin: (params = {}) =>
        api.get("/admin/provider-types", { params }).then((r) => r.data),
    create: (payload) =>
        api.post("/admin/provider-types", payload).then((r) => r.data),
    update: (id, payload) =>
        api.patch(`/admin/provider-types/${id}`, payload).then((r) => r.data),
    delete: (id) =>
        api.delete(`/admin/provider-types/${id}`).then((r) => r.data),
};
